export const fileSizeLimitInMB = parseInt(process.env.REACT_APP_FILE_SIZE_LIMIT_MB || '0');
export const pageLimit = parseInt(process.env.REACT_APP_FILE_PAGE_LIMIT || '0');
export const wordLimit = parseInt(process.env.REACT_APP_FILE_WORD_LIMIT || '0');